document.addEventListener("DOMContentLoaded", function(){

  const form = document.getElementById("loyalty-form");
  if(!form) return;

  const requiredFields = form.querySelectorAll("[data-required]");
  const submitBtn = form.querySelector('button[type="submit"]');

  let attemptedSubmit = false;


  function showError(field, message){

    let errorSpan;

    if(field.type === "checkbox"){
      errorSpan = form.querySelector(".checkbox-error");
    }else{
      errorSpan = field.closest(".form-field").querySelector(".error-message");
      field.classList.add("input-error");
    }

    if(errorSpan){
      errorSpan.textContent = message;
    }
  }

  function clearError(field){

    let errorSpan;

    if(field.type === "checkbox"){
      errorSpan = form.querySelector(".checkbox-error");
    }else{
      errorSpan = field.closest(".form-field").querySelector(".error-message");
      field.classList.remove("input-error");
    }

    if(errorSpan){
      errorSpan.textContent = "";
    }
  }


  // VALIDITY CHECK
  function isFormValid(){

    let valid = true;

    requiredFields.forEach(field => {

      if(field.type === "checkbox"){

        if(!field.checked){
          valid = false;
        }

      }else{

        if(!field.value.trim()){
          valid = false;
        }

        if(field.dataset.email === "true"){

          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if(!regex.test(field.value)){
            valid = false;
          }
        }
      }
    });

    return valid;
  }


  // CONTROL BUTTON ONLY AFTER FIRST SUBMIT
  function updateButtonState(){

    if(!attemptedSubmit) return;

    submitBtn.disabled = !isFormValid();
  }



  // LIVE FIELD LISTENERS
  requiredFields.forEach(field => {

    field.addEventListener("input", () => {

      if(attemptedSubmit){
        clearError(field);
        updateButtonState();
      }

    });

    field.addEventListener("change", () => {

      if(attemptedSubmit){
        clearError(field);
        updateButtonState();
      }

    });

  });


  // SUBMIT EVENT
  form.addEventListener("submit", function(e){

    attemptedSubmit = true;

    let hasErrors = false;

    requiredFields.forEach(field => {

      if(field.type === "checkbox"){

        if(!field.checked){
          showError(field,"This is a required field");
          hasErrors = true;
        }

      }else{

        if(!field.value.trim()){
          showError(field,"This is a required field");
          hasErrors = true;
        }

        if(field.dataset.email === "true"){

          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if(field.value && !regex.test(field.value)){
            showError(field,"Enter a valid email");
            hasErrors = true;
          }
        }
      }

    });

    if(hasErrors){
      e.preventDefault();
      submitBtn.disabled = true;
      return;
    }
    submitBtn.disabled = true;

  });

});
